<template>
  <div>
    <b-alert variant="danger" :show="supplierData === undefined">
      <h4 class="alert-heading">Error fetching supplier data</h4>
      <div class="alert-body">
        No supplier found with this supplier id. Check
        <b-link class="alert-link" :to="{ name: 'suppliers-list' }">
          supplier List
        </b-link>
        for other suppliers.
      </div>
    </b-alert>
    <div v-if="supplierData && Object.keys(supplierData).length > 0">
      <Modal-Pdf :title="title" :pdf-url="pdfUrl" />

      <modal-image-viewer
        :image-list="previewImage"
        :selected_file="selected_file"
      ></modal-image-viewer>

      <modal-upload-bill
        apiUrl="/suppliers/documents"
        :document-data="documentData"
        :invoice-options="invoiceOptions"
        :user_id="supplierData.id"
        @refetch-data="isSubmitDocument = !isSubmitDocument"
      />

      <modal-upload-payment-proof
        :bill-data="selectedBillData"
        :payment-proof-data="selectedPaymentProofData"
        :payment-method-options="paymentMethodOptions"
        :is-edit="isEditPaymentProof"
        @refetch-data="refetchData"
      />

      <modal-upload-payment-receipt
        :bill-data="selectedBillData"
        :payment-proof-data="selectedPaymentProofData"
        :payment-receipt-data="selectedPaymentReceiptData"
        :is-edit="isEditPaymentReceipt"
        @refetch-data="isSubmitDocument = !isSubmitDocument"
      />

      <modal-approval :approve-data="approveData" @refetch-data="refetchData" />

      <supplier-document-detail
        :document-detail="documentDetailData"
        :invoice-options="invoiceOptions"
        @edit="handleModelDocument"
        @delete="removeDocument"
      />

      <b-card no-body class="p-1 px-2">
        <!-- supplier Info: Top col -->
        <div
          class="d-flex flex-wrap align-items-center justify-content-between"
        >
          <h4 class="mb-1 mb-sm-0 ml-0 font-weight-bolder text-nowrap">
            <feather-icon class="mr-50" icon="BriefcaseIcon" />
            供應商資料
          </h4>
          <div class="d-flex flex-wrap justify-content-end">
           
            <b-button
              v-if="(ability.can('update', 'staff_supplier_detail') && userData.user_type_id === 1)"
              class="px-3 mx-1 mobile-w100 mb-1 mb-sm-0 backgroundColor1 no-border"
              :to="{ name: 'supplier-edit', params: { id: supplierData.id } }"
              ><feather-icon
                class="mr-50"
                size="14"
                icon="Edit2Icon"
              />編輯</b-button
            >
            <!-- <b-button
              v-if="
                (ability.can('read', 'setting_suppliers') &&
                  whitch_page == 1) ||
                (ability.can('read', 'staff_suppliers') && whitch_page == 2)
              "
              class="mobile-w100 mb-1 mb-sm-0 px-3 mx-1"
              type="button"
              variant="outline-secondary"
              @click="hide"
            >
              返回
            </b-button> -->
          </div>
        </div>
        <hr />
        <b-row class="info-wrap px-1">
          <b-col class="mb-1 mb-sm-0" cols="12" sm="12" md="4">
            <h4 class="mb-0 font-weight-bolder">{{ supplierData.name }}</h4>
            <h5 class="mb-0 font-weight-bolder">{{ supplierData.name_cn }}</h5>
            <br />
            <div class="">
              <label class="info-label">供應商編號:</label
              ><span>{{ supplierData.user_number }}</span>
            </div>
            <!-- <div><label>職位:</label><span>{{ supplierData.position }}</span></div> -->
            <div class="">
              <label class="info-label">狀態:</label>
              <span class="colorRed">
                <feather-icon
                  v-if="supplierData.is_active"
                  icon="CheckIcon"
                  size="18"
                  class="mr-50 text-success"
                />
              </span>
              <span class="colorRed">
                <feather-icon
                  v-if="supplierData.locked"
                  icon="LockIcon"
                  size="18"
                  class="mr-50 text-danger"
                />
              </span>
            </div>
          </b-col>

          <!-- gender -->
          <b-col title="gender" cols="12" sm="6" md="4">
            <div class="info-item">
              <span class="icon">
                <font-awesome-icon icon="fa-solid fa-person" class="" />
              </span>
              {{ supplierData.company_name_cn }}
            </div>
            <div class="info-item">
              <span class="icon">
                <font-awesome-icon icon="fa-solid fa-phone" class="" />
              </span>
              {{ supplierData.phone }}
            </div>

            <div class="info-item">
              <span class="icon">
                <font-awesome-icon icon="fa-solid fa-envelope" class="" />
              </span>
              {{ supplierData.email }}
            </div>
          </b-col>

          <!-- tel -->
          <b-col cols="12" sm="6" md="4">
            <div class="info-item">
              <span class="icon">
                <font-awesome-icon icon="fa-solid fa-location-dot" class="" />
              </span>
              {{ supplierData.address }}
            </div>
            <div class="info-item">
              <span class="icon">
                <font-awesome-icon
                  icon="fa-solid fa-building-columns"
                  class=""
                />
              </span>
              {{ supplierData.bank && supplierData.bank.name }}
            </div>
            <div class="info-item">
              <span class="icon">
                <font-awesome-icon icon="fa-solid fa-credit-card" class="" />
              </span>
              {{ supplierData.bank_account }}
            </div>
          </b-col>
        </b-row>
      </b-card>
    </div>

    <div>  
    <!-- v-if="
        (ability.can('document', 'setting_supplier_detail') &&
          whitch_page == 1) ||
        (ability.can('document', 'staff_supplier_detail') &&
          whitch_page == 2) ||
        (ability.can('document', 'supplier_detail') && whitch_page == 3) ||
        ability.can('read', 'staff_supplier_documents')
      " -->
      <b-card id="downloadWrapper" style="height: 100%">
        <div class="d-flex align-items-center justify-content-between">
          <div class="d-flex align-items-center">
            <h4
              class="mb-0 ml-0 d-flex aling-items-center left-bold-border before-color-2 font-weight-bolder"
            >
              帳單
            </h4>
          </div>
          <div class="d-flex align-items-center">
            <div class="ml-1">
              <span> 開支類型: </span>
              <v-select
                v-model="expenseTypeFilter"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="expenseTypeOptions"
                :reduce="(option) => option.value"
                label="label"
                :clearable="false"
                class="expense-type-selector d-inline-block ml-1"
                placeholder="開支類型"
                style="min-width: 120px"
              />
            </div>
            <div class="ml-1 mr-2">
              <span> 埋數狀態: </span>
              <v-select
                v-model="approvalStatusFilter"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="approvalStatusOptions"
                :reduce="(option) => option.value"
                label="label"
                :clearable="false"
                class="approval-status-selector d-inline-block ml-1"
                placeholder="埋數狀態"
                style="min-width: 120px"
              />
            </div>
            <b-button
              variant="primary"
              class="d-flex py-50 px-3 align-items-center mr-1"
              @click="handleModelDocument(false)"
              v-if="
                (ability.can('upload_document', 'staff_supplier_detail') &&
                  userData.user_type_id === 1) ||
                (ability.can('upload_document', 'supplier_detail') &&
                  userData.user_type_id === 3)
              "
            >
              <feather-icon icon="PlusIcon" size="20" />
              上傳帳單
            </b-button>
            <b-button
              variant="outline-secondary"
              class="d-flex py-50 px-3 align-items-center"
              @click="handleExport"
              :disabled="isExporting"
              v-if="
                (ability.can('export', 'staff_supplier_detail') &&
                  userData.user_type_id === 1) ||
                (ability.can('export', 'supplier_detail') && userData.user_type_id === 3)
              "
            >
              <b-spinner v-if="isExporting" small class="mr-1" />
              <feather-icon v-else icon="DownloadIcon" size="20" />
              {{ isExporting ? "匯出中..." : "匯出 Excel" }}
            </b-button>
          </div>
        </div>

        <!-- 金額統計卡片 -->
        <b-row class="mt-3 mb-3">
          <b-col md="4">
            <b-card class="text-center">
              <h5 class="text-primary mb-1">${{ totalAmount }}</h5>
              <small class="text-muted">總額</small>
            </b-card>
          </b-col>
          <b-col md="4">
            <b-card class="text-center">
              <h5 class="text-success mb-1">${{ approvedAmount }}</h5>
              <small class="text-muted">已埋數總額</small>
            </b-card>
          </b-col>
          <b-col md="4">
            <b-card class="text-center">
              <h5 class="text-warning mb-1">${{ pendingAmount }}</h5>
              <small class="text-muted">未埋數總額</small>
            </b-card>
          </b-col>
        </b-row>

        <div class="mt-2">
          <b-table
            ref="refSupplierDocumentListTable"
            class="position-relative"
            :items="fetchSupplierDocuments"
            responsive
            :fields="documentTableColumns"
            primary-key="id"
            show-empty
            empty-text="未找到匹配的記錄"
          >
            <!-- 帳單預覽 -->
            <template #cell(bill_preview)="data">
              <div class="text-center preview-column">
                <div class="previewWrapper">
                  <template
                    v-if="
                      data.item.image_url &&
                      data.item.image_url.indexOf('.pdf') > -1
                    "
                  >
                    <embed
                      class="pdf"
                      style="max-width: 100px; max-height: 100px"
                      :src="data.item.image_url"
                      type="application/pdf"
                    />
                  </template>
                  <template v-else-if="data.item.image_url">
                    <img
                      style="max-width: 80px; max-height: 80px"
                      :src="data.item.image_url"
                      alt="帳單"
                      class="img-fluid"
                    />
                  </template>
                </div>
                <div class="" v-if="data.item.image_url">
                  <a
                    class="color1 text-sm"
                    @click="previewImageSet(supplierDocuments, data.index)"
                    >預覽</a
                  >
                  <div>{{ data.item.bill_number }}</div>
                </div>
                <div v-else-if="(ability.can('upload_document', 'staff_supplier_detail') && userData.user_type_id === 1) || (ability.can('upload_document', 'supplier_detail') && userData.user_type_id === 3)" class="mt-1">
                  <b-button
                    size="sm"
                    variant="outline-secondary"
                    class="upload-btn"
                    @click="handleModelDocument(data.item)"
                  >
                    <feather-icon icon="UploadIcon" size="12" class="mr-50" />
                    未上傳
                  </b-button>
                </div>
                <!-- 編輯帳單按鈕 -->
                <div class="mt-2">
                  <b-button
                    v-if="
                      (ability.can(
                        'update_document',
                        'staff_supplier_detail'
                      ) &&
                        userData.user_type_id === 1) ||
                      (ability.can('update_document', 'supplier_detail') &&
                        userData.user_type_id === 3)
                    "
                    size="sm"
                    variant="outline-primary"
                    @click="handleModelDocument(data.item)"
                  >
                    <feather-icon icon="EditIcon" size="14" />
                    編輯
                  </b-button>
                </div>
                <!-- 刪除帳單按鈕 -->
                <div class="mt-2">
                  <b-button
                    v-if="
                      (ability.can(
                        'delete_document_file',
                        'staff_supplier_detail'
                      ) &&
                        userData.user_type_id === 1) ||
                      (ability.can('delete_document_file', 'supplier_detail') &&
                        userData.user_type_id === 3)
                    "
                    size="sm"
                    variant="outline-danger"
                    @click="deleteRecord(data.item.id, 'deleteSupplierBillFiles')"
                  >
                    <feather-icon icon="TrashIcon" size="14" />
                    刪除帳單文件
                  </b-button>
                </div>
              </div>
            </template>

            <!-- 付款憑證預覽（支援多筆憑證） -->
            <template #cell(payment_proof_preview)="data">
              <div class="text-center preview-column">
                <template v-if="hasPaymentProof(data.item)">
                  <div class="previewWrapper position-relative">
                    <!-- 多筆付款憑證的堆疊顯示效果 -->
                    <template v-if="data.item.payment_proofs && data.item.payment_proofs.length > 1">
                      <!-- <div
                        class="payment-proof-shadow"
                        style="position: absolute; top: 3px; left: 3px; width: 80px; height: 80px; background: #e9ecef; border-radius: 4px; z-index: 1;"
                      ></div> -->
                      <div style="position: relative; z-index: 2;">
                        <template v-if="getPaymentProofFileType(data.item) === 'pdf'">
                          <embed
                            class="pdf"
                            style="max-width: 80px; max-height: 80px"
                            :src="getPaymentProofImageUrl(data.item)"
                            type="application/pdf"
                          />
                        </template>
                        <template v-else>
                          <img
                            style="max-width: 80px; max-height: 80px"
                            :src="getPaymentProofImageUrl(data.item)"
                            alt="付款憑證"
                            class="img-fluid"
                          />
                        </template>
                      </div>
                      <!-- 數量標籤 -->
                      <!-- <b-badge
                        variant="primary"
                        class="position-absolute"
                        style="top: -5px; right: -5px; z-index: 3; font-size: 10px;"
                      >
                        {{ data.item.payment_proofs.length }}
                      </b-badge> -->
                    </template>

                    <!-- 單筆付款憑證的正常顯示 -->
                    <template v-else>
                      <template v-if="getPaymentProofFileType(data.item) === 'pdf'">
                        <embed
                          class="pdf"
                          style="max-width: 80px; max-height: 80px"
                          :src="getPaymentProofImageUrl(data.item)"
                          type="application/pdf"
                        />
                      </template>
                      <template v-else>
                        <img
                          style="max-width: 80px; max-height: 80px"
                          :src="getPaymentProofImageUrl(data.item)"
                          alt="付款憑證"
                          class="img-fluid"
                        />
                      </template>
                    </template>
                  </div>
                  <div class="">
                    <a class="color1 text-sm" @click="previewPaymentProof(data.item)">預覽</a>
                    <div>{{ getPaymentProofNumber(data.item) }}</div>
                  </div>
                  <!-- 編輯付款憑證按鈕 -->
                  <div class="mt-2">
                    <b-button
                      v-if="
                        (ability.can('edit_payment_proof', 'staff_supplier_detail') && userData.user_type_id === 1) ||
                        (ability.can('edit_payment_proof', 'supplier_detail') && userData.user_type_id === 3)
                      "
                      size="sm"
                      variant="outline-success"
                      @click="handleUploadPaymentProof(data.item)"
                    >
                      <feather-icon icon="EditIcon" size="14" />
                      編輯
                    </b-button>
                  </div>
                  <!-- 刪除付款憑證按鈕 -->
                  <div class="mt-2">
                    <b-button
                      v-if="
                        (ability.can('delete_payment_proof', 'staff_supplier_detail') && userData.user_type_id === 1) ||
                        (ability.can('delete_payment_proof', 'supplier_detail') && userData.user_type_id === 3)
                      "
                      size="sm"
                      variant="outline-danger"
                      @click="deleteRecord(data.item.id, 'deleteSupplierPaymentProof')"
                    >
                      <feather-icon icon="TrashIcon" size="14" />
                      刪除付款憑證紀錄
                    </b-button>
                  </div>
                </template>
                <template v-else-if="(ability.can('upload_payment_proof', 'staff_supplier_detail') && userData.user_type_id === 1) || (ability.can('upload_payment_proof', 'supplier_detail') && userData.user_type_id === 3)">
                  <div class="mt-1">
                    <b-button
                      v-if="data.item.image_url"
                      size="sm"
                      variant="outline-success"
                      class="upload-btn"
                      @click="handleUploadPaymentProof(data.item)"
                    >
                      <feather-icon icon="UploadIcon" size="12" class="mr-50" />
                      未上傳
                    </b-button>
                    <b-button
                      v-else
                      size="sm"
                      variant="outline-secondary"
                      class="upload-btn"
                      disabled
                      v-b-tooltip.hover
                      title="請先上傳帳單"
                    >
                      <feather-icon icon="LockIcon" size="12" class="mr-50" />
                      未上傳
                    </b-button>
                  </div>
                </template>
              </div>
            </template>

            <!-- 付款收據預覽 -->
            <template #cell(payment_receipt_preview)="data">
              <div class="text-center preview-column">
                <template
                  v-if="
                    data.item.payment_receipt_path ||
                    data.item.payment_receipt_url
                  "
                >

                <div class="previewWrapper">
                  <template
                    v-if="
                      (
                        data.item.payment_receipt_url ||
                        data.item.payment_receipt_path ||
                        ''
                      ).indexOf('.pdf') > -1
                    "
                  >
                    <embed
                      class="pdf"
                      style="max-width: 100px; max-height: 100px"
                      :src="getPaymentReceiptImageUrl(data.item)"
                      type="application/pdf"
                    />
                  </template>
                  <template v-else>
                    <img
                      style="max-width: 80px; max-height: 80px"
                      :src="getPaymentReceiptImageUrl(data.item)"
                      alt="付款收據"
                      class="img-fluid"
                    />
                  </template>
                  </div>
                  <div class="">
                    <a
                      class="color1 text-sm"
                      @click="previewPaymentReceipt(data.item)"
                      >預覽</a
                    >
                    <div>{{ data.item.receipt_number }}</div>
                  </div>
                  <!-- 編輯付款收據按鈕 -->
                  <div class="mt-2">
                    <b-button
                      v-if="
                        (ability.can(
                          'edit_payment_receipt',
                          'staff_supplier_detail'
                        ) &&
                         userData.user_type_id === 1) ||
                        (ability.can(
                          'edit_payment_receipt',
                          'supplier_detail'
                        ) &&
                         userData.user_type_id === 3)
                      "
                      size="sm"
                      variant="outline-warning"
                      @click="handleUploadPaymentReceipt(data.item)"
                    >
                      <feather-icon icon="EditIcon" size="14" />
                      編輯
                    </b-button>
                  </div>
                  <!-- 刪除付款收據按鈕 -->
                  <div class="mt-2">
                    <b-button
                      v-if="
                        (ability.can(
                          'delete_payment_receipt',
                          'staff_supplier_detail'
                        ) &&
                         userData.user_type_id === 1) ||
                        (ability.can(
                          'delete_payment_receipt',
                          'supplier_detail'
                        ) &&
                         userData.user_type_id === 3)
                      "
                      size="sm"
                      variant="outline-danger"
                      @click="deleteRecord(data.item.id, 'deleteSupplierPaymentReceipt')"
                    >
                      <feather-icon icon="TrashIcon" size="14" />
                      刪除付款收據紀錄
                    </b-button>
                  </div>
                </template>
                <template v-else-if="(ability.can('upload_payment_receipt', 'staff_supplier_detail') && userData.user_type_id === 1) || (ability.can('upload_payment_receipt', 'supplier_detail') && userData.user_type_id === 3)">
                  <div class="mt-1">
                    <b-button
                      v-if="
                        data.item.image_url &&
                        hasPaymentProof(data.item)
                      "
                      size="sm"
                      variant="outline-warning"
                      class="upload-btn"
                      @click="handleUploadPaymentReceipt(data.item)"
                    >
                      <feather-icon icon="UploadIcon" size="12" class="mr-50" />
                      未上傳
                    </b-button>
                    <b-button
                      v-else
                      size="sm"
                      variant="outline-secondary"
                      class="upload-btn"
                      disabled
                      v-b-tooltip.hover
                      :title="
                        !data.item.image_url ? '請先上傳帳單' : '請先上傳付款憑證'
                      "
                    >
                      <feather-icon icon="LockIcon" size="12" class="mr-50" />
                      未上傳
                    </b-button>
                  </div>
                </template>
              </div>
            </template>
            <template #cell(is_daily_expense)="data">
              <b-badge
                :variant="data.item.is_daily_expense ? 'success' : 'danger'"
              >
                {{ data.item.is_daily_expense ? "日常開支" : "成本開支" }}
              </b-badge>
            </template>

            <!-- 詳情 -->
            <template #cell(show_details)="row">
              <b-button
                size="sm"
                class="mr-2"
                variant="info"
                @click="row.toggleDetails()"
            >
              {{ row.detailsShowing ? "隱藏" : "顯示" }}
              </b-button>
            </template>

            <template #cell(amount)="data"> ${{ data.item.amount }} </template>

            <template #cell(bill_date)="data">
              {{ data.item.bill_date ? getDate(data.item.bill_date) : "-" }}
            </template>

            <template #cell(bill_total_amount)="data">
              <span class="text-primary font-weight-bold">
                ${{ Number(data.item.bill_total_amount || 0).toFixed(2) }}
              </span>
            </template>

            <template #cell(is_approved)="data">
              <!-- 自動埋數邏輯：有付款憑證時自動標記為已埋數 -->
              <b-badge :variant="getApprovalStatus(data.item).variant">
                {{ getApprovalStatus(data.item).text }}
              </b-badge>
            </template>

            <template #cell(created_at)="data">
              {{ getDateTime(data.item.created_at) }}
            </template>

            <template #cell(actions)="data">
              <b-dropdown
                :class="`action-trigger-btn ${
                  supplierDocuments.length <= 3 ? 'hor' : 'ver'
                }`"
                :right="$store.state.appConfig.isRTL"
              >
                <template #button-content>
                  <feather-icon
                    icon="EyeIcon"
                    size="16"
                    class="align-middle text-body"
                  />
                </template>

                <!-- <b-dropdown-item
                  v-if="ability.can('view_detail', 'staff_supplier_documents')"
                  @click="handleViewDetail(data.item)"
                >
                  <feather-icon icon="EyeIcon" />
                  <span class="align-middle ml-50">查看詳情</span>
                </b-dropdown-item> -->

                <!-- 註釋掉手動埋數按鈕，改為自動埋數 -->
                <!-- <b-dropdown-item
                  v-if="
                    ability.can('approve', 'staff_supplier_detail') &&
                    whitch_page == 2
                  "
                  @click="handleApproval(data.item)"
                >
                  <feather-icon icon="CheckIcon" />
                  <span class="align-middle ml-50">埋數</span>
                </b-dropdown-item> -->

                <b-dropdown-item
                  v-if="
                    !hasPaymentProof(data.item) &&
                      ((ability.can('upload_payment_proof', 'staff_supplier_detail') && userData.user_type_id === 1) ||
                      (ability.can('upload_payment_proof', 'supplier_detail') && userData.user_type_id === 3))
                  "
                  @click="handleUploadPaymentProof(data.item)"
                >
                  <feather-icon icon="UploadIcon" />
                  <span class="align-middle ml-50">上傳付款憑證</span>
                </b-dropdown-item>

                <b-dropdown-item
                  v-if="
                    hasPaymentProof(data.item) &&
                    !data.item.payment_receipt_path &&
                    ((ability.can('upload_payment_receipt', 'staff_supplier_detail') && userData.user_type_id === 1) ||
                      (ability.can('upload_payment_receipt', 'supplier_detail') && userData.user_type_id === 3))
                  "
                  @click="handleUploadPaymentReceipt(data.item)"
                >
                  <feather-icon icon="UploadIcon" />
                  <span class="align-middle ml-50">上傳付款收據</span>
                </b-dropdown-item>

                <b-dropdown-item
                  v-if="
                    (ability.can('update_document', 'staff_supplier_detail') &&
                      userData.user_type_id === 1) ||
                    (ability.can('update_document', 'supplier_detail') &&
                      userData.user_type_id === 3)
                  "
                  @click="handleModelDocument(data.item)"
                >
                  <feather-icon icon="EditIcon" />
                  <span class="align-middle ml-50">編輯供應商帳單</span>
                </b-dropdown-item>

                <b-dropdown-item
                  v-if="data.item.image_url && 
                    (
                      (ability.can(
                        'print',
                        'staff_supplier_detail'
                      ) &&
                        userData.user_type_id === 1) ||
                      (ability.can('print', 'supplier_detail') &&
                        userData.user_type_id === 3)
                    )
                  "
                  @click="handlePrintBillDetail(data.item)"
                >
                  <feather-icon icon="PrinterIcon" />
                  <span class="align-middle ml-50">列印帳單明細</span>
                </b-dropdown-item>

                <b-dropdown-item
                  v-if="
                    (ability.can('delete_document', 'staff_supplier_detail') &&
                      userData.user_type_id === 1) ||
                    (ability.can('delete_document', 'supplier_detail') &&
                      userData.user_type_id === 3)
                  "
                  @click="removeDocument(data.item.id)"
                >
                  <feather-icon icon="Trash2Icon" />
                  <span class="align-middle ml-50">刪除供應商帳單記錄</span>
                </b-dropdown-item>
              </b-dropdown>
            </template>

            <template #row-details="row">
              <div
               
                class="details-container p-2 bg-light border-left border-info"
              >
                <!-- 帳單詳情 -->
                <div class="bill-details mb-4">
                  <div class="detail-section">
                    <div class="detail-header d-flex align-items-center mb-3">
                      <div
                        class="detail-icon bg-info text-white rounded-circle d-flex align-items-center justify-content-center mr-3"
                        style="width: 32px; height: 32px"
                      >
                        <feather-icon icon="FileTextIcon" size="16" />
                      </div>
                      <h6 class="mb-0 text-info font-weight-bold">帳單詳情</h6>
                    </div>
                    <div class="detail-content bg-white rounded p-3 shadow-sm">
                      <div v-if="row.item.items && row.item.items.length > 0">
                        <div
                          class="bill-item border-bottom pb-3 mb-3"
                          v-for="(item, index) in row.item.items"
                          :key="`bill_item_${index}`"
                        >
                          <b-row>
                            <b-col cols="12">
                            <div class="detail-row d-flex mb-2">
                              <span class="detail-label text-muted">帳單編號：</span>
                              <span class="detail-value ml-2 font-weight-medium">{{ row.item.bill_number == 'null' ? '-' : (row.item.bill_number || '-') }}</span>
                            </div>

                              <!-- 根據開支類型顯示不同的欄位 -->
                              <!-- 日常開支：顯示開支日期 -->
                              <div v-if="row.item.is_daily_expense == 1 || row.item.is_daily_expense === true || row.item.is_daily_expense === '1'" class="detail-row d-flex mb-2">
                                <span class="detail-label text-muted">開支日期：</span>
                                <span class="detail-value ml-2 font-weight-medium">
                                  {{ item.daily_expense_date ? getDate(item.daily_expense_date) : '-' }}
                                </span>
                              </div>

                              <!-- 成本開支：顯示發票編號 -->
                              <div v-else class="detail-row d-flex mb-2">
                                <span class="detail-label text-muted"
                                  >發票編號：</span
                                >
                                <span
                                  class="detail-value ml-2 font-weight-medium"
                                >
                                  <template
                                    v-if="
                                      item.invoice_id &&
                                      getInvoiceNumber(item.invoice_id)
                                    "
                                  >
                                    <router-link
                                      :to="{
                                        name: 'invoice-edit',
                                        params: { id: item.invoice_id },
                                      }"
                                      class="text-primary text-decoration-none"
                                      target="_blank"
                                    >
                                      {{ getInvoiceNumber(item.invoice_id) }}
                                      <!-- <feather-icon icon="ExternalLinkIcon" size="14" class="ml-1" /> -->
                                    </router-link>
                                  </template>
                                  <template v-else> - </template>
                                </span>
                              </div>

                              <div class="detail-row d-flex mb-2">
                                <span class="detail-label text-muted"
                                  >帳單備註：</span
                                >
                                <span
                                  class="detail-value ml-2 font-weight-medium"
                                  >{{ item.title == 'null' ? '-' : item.title || "-" }}</span
                                >
                              </div>
                              <div class="detail-row d-flex mb-2">
                                <span class="detail-label text-muted"
                                  >金額：</span
                                >
                                <span
                                  class="detail-value ml-2 text-success font-weight-bold"
                                >
                                  ${{ Number(item.amount || 0).toFixed(2) }}
                                </span>
                              </div>
                            </b-col>
                          </b-row>
                        </div>
                      </div>
                      <div v-else class="text-center text-muted py-4">
                        <feather-icon
                          icon="InfoIcon"
                          size="24"
                          class="mb-2 text-muted"
                        />
                        <p class="mb-0">此帳單沒有詳細資訊</p>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- 付款憑證詳情 -->
                <div class="payment-proof-details mb-4">
                  <div class="detail-section">
                    <div class="detail-header d-flex align-items-center mb-3">
                      <div
                        class="detail-icon bg-success text-white rounded-circle d-flex align-items-center justify-content-center mr-3"
                        style="width: 32px; height: 32px"
                      >
                        <feather-icon icon="CreditCardIcon" size="16" />
                      </div>
                      <h6 class="mb-0 text-success font-weight-bold">
                        付款憑證詳情
                      </h6>
                    </div>
                    <div class="detail-content bg-white rounded p-3 shadow-sm">
                      <div v-if="hasPaymentProof(row.item)">
                        <b-row>
                          <b-col cols="12">
                            <div class="detail-row d-flex mb-3">
                              <span class="detail-label text-muted">付款憑證編號：</span>
                              <span class="detail-value ml-2 text-success font-weight-medium">
                                {{ getPaymentProofNumber(row.item) || '-' }}
                              </span>
                            </div>
                            <div class="detail-row d-flex mb-3">
                              <span class="detail-label text-muted">支付日期：</span>
                              <span class="detail-value ml-2">{{
                                row.item.payment_date ? getDate(row.item.payment_date) : '-'
                              }}</span>
                            </div>
                            <div class="detail-row d-flex mb-3">
                              <span class="detail-label text-muted">支付金額：</span>
                              <span class="detail-value ml-2 text-success font-weight-bold">
                                {{
                                  row.item.payment_proofs && row.item.payment_proofs.length > 0
                                    ? `$${row.item.payment_proofs.reduce((s, p) => s + (Number(p.payment_amount) || 0), 0).toFixed(2)}`
                                    : `$${(Number(row.item.payment_amount || row.item.bill_total_amount || 0)).toFixed(2)}`
                                }}
                              </span>
                            </div>
                          </b-col>
                          <b-col cols="12">
                            <div class="detail-row d-flex mb-3">
                              <span class="detail-label text-muted">支付方式：</span>
                              <span class="detail-value ml-2">
                                {{ row.item.payment_method_id ? getPaymentMethodName(row.item.payment_method_id, row.item.check_number) : '-' }}
                              </span>
                            </div>
                          </b-col>
                        </b-row>
                      </div>
                      <div v-else class="text-center text-muted py-4">
                        <feather-icon icon="InfoIcon" size="24" class="mb-2 text-muted" />
                        <p class="mb-0">此記錄沒有付款憑證資訊</p>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- 付款收據詳情 -->
                <div class="payment-receipt-details">
                  <div class="detail-section">
                    <div class="detail-header d-flex align-items-center mb-3">
                      <div
                        class="detail-icon bg-warning text-white rounded-circle d-flex align-items-center justify-content-center mr-3"
                        style="width: 32px; height: 32px"
                      >
                        <feather-icon icon="BookIcon" size="16" />
                      </div>
                      <h6 class="mb-0 text-warning font-weight-bold">
                        付款收據詳情
                      </h6>
                    </div>
                    <div class="detail-content bg-white rounded p-3 shadow-sm">
                      <div v-if="row.item.payment_receipt_url">
                        <b-row>
                          <b-col cols="12">
                            <div class="detail-row d-flex mb-3">
                              <span class="detail-label text-muted"
                                >收據編號：</span
                              >
                              <span
                                class="detail-value ml-2 text-success font-weight-medium"
                                >{{ row.item.receipt_number || "-" }}</span
                              >
                            </div>
                            <div class="detail-row d-flex mb-3">
                              <span class="detail-label text-muted"
                                >收據備註：</span
                              >
                              <span class="detail-value ml-2">{{
                                row.item.payment_receipt_remark == 'null' ?  '-' : row.item.payment_receipt_remark || "-"
                              }}</span>
                            </div>
                          </b-col>
                          <b-col cols="12">
                            <div class="detail-row d-flex mb-3">
                              <span class="detail-label text-muted"
                                >收據日期：</span
                              >
                              <span class="detail-value ml-2">{{
                                row.item.receipt_date
                                  ? getDate(row.item.receipt_date)
                                  : "-"
                              }}</span>
                            </div>
                            <!-- <div class="detail-row d-flex mb-3">
                            <span class="detail-label text-muted">上傳日期：</span>
                            <span class="detail-value ml-2">{{
                              row.item.created_at
                                ? getDateTime(row.item.created_at)
                                : "-"
                            }}</span>
                          </div> -->
                          </b-col>
                        </b-row>
                      </div>
                      <div v-else class="text-center text-muted py-4">
                        <feather-icon
                          icon="InfoIcon"
                          size="24"
                          class="mb-2 text-muted"
                        />
                        <p class="mb-0">此記錄沒有付款收據資訊</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </b-table>
          <!-- <div class="mt-2 d-flex justify-content-end align-items-center">
            <span>總額：${{ totalAmount }}</span>
          </div> -->
        </div>
      </b-card>
    </div>
  </div>
</template>

<script>
import {
  BCard,
  BCardBody,
  BTable,
  BBadge,
  BRow,
  BCol,
  BAlert,
  BLink,
  BButton,
  BDropdown,
  BDropdownItem,
  BCollapse,
  BSpinner,
  VBToggle,
} from "bootstrap-vue";
import { ref, onUnmounted, onMounted, watch, getCurrentInstance } from "@vue/composition-api";
import vSelect from "vue-select";
import router from "@/router";
import store from "@/store";
import { formatCurrency } from "@core/utils/filter";
import supplierStoreModule from "./supplierStoreModule";
import ability from "@/libs/acl/ability";
import ModalPdf from "@/layouts/components/file/ModalPdf.vue";
import ModalImageViewer from "@/layouts/components/file/ModalImageViewer.vue";
import ModalUploadBill from "./modal/ModalUploadBill.vue";
import ModalUploadPaymentProof from "./modal/ModalUploadPaymentProof.vue";
import ModalUploadPaymentReceipt from "./modal/ModalUploadPaymentReceipt.vue";
import ModalApproval from "./modal/ModalApproval";
import SupplierDocumentDetail from "./modal/SupplierDocumentDetail.vue";

export default {
  components: {
    BCard,
    BCardBody,
    BTable,
    BBadge,
    BRow,
    BCol,
    BAlert,
    BLink,
    BButton,
    BDropdown,
    BDropdownItem,
    BCollapse,
    BSpinner,
    vSelect,
    ModalPdf,
    ModalImageViewer,
    ModalUploadBill,
    ModalUploadPaymentProof,
    ModalUploadPaymentReceipt,
    ModalApproval,
    SupplierDocumentDetail,
  },
  data() {
    return {
      ability,
      pdfUrl: null,
      loadingPDF: false,
      title: null,
      previewImage: null,
      selected_file: null,
      userData: JSON.parse(localStorage.getItem("userData")),
      approveData: null,
      documentData: {},
      documentDetailData: {},
      selectedBillData: {},
      selectedPaymentProofData: {},
      selectedPaymentReceiptData: {},
      isEditPaymentProof: false,
      isEditPaymentReceipt: false,
      // 詳情顯示狀態管理
      detailsShowing: {}, // 詳情顯示狀態 { documentId: boolean }
    };
  },
  directives: {
    "b-toggle": VBToggle,
  },
  computed: {
    // whitch_page() {
    //   if (router.currentRoute.name == "setting-supplier-view") {
    //     return 1;
    //   } else if (router.currentRoute.name == "staff-supplier-view") {
    //     return 2;
    //   } else {
    //     return 3;
    //   }
    // },
  },
  methods: {
    // hide() {
    //   if (router.currentRoute.name == "setting-supplier-view") {
    //     this.$router.replace("/users/list");
    //   } else if (router.currentRoute.name == "staff-supplier-view") {
    //     this.$router.replace("/staff-supplier/list");
    //   }
    // },

    // 自動埋數邏輯：有付款憑證時自動標記為已埋數（支援多筆）
    getApprovalStatus(item) {
      const hasProof = this.hasPaymentProof(item);
      if (hasProof) {
        return { variant: "success", text: "已埋數" };
      }
      return { variant: "warning", text: "未埋數" };
    },
    // 獲取完整圖片 URL - 修復生產環境圖片顯示問題
    getFullImageUrl(url) {
      if (!url) return "";

      // 如果已經是完整 URL，直接返回
      if (url.startsWith("http://") || url.startsWith("https://")) {
        return url;
      }

      // 構建完整 URL，確保在生產環境正確顯示
      const baseUrl =
        process.env.VUE_APP_API_BASE_URL || "http://127.0.0.1:8000";
      // 確保 URL 路徑正確拼接
      const fullUrl = url.startsWith("/")
        ? `${baseUrl}${url}`
        : `${baseUrl}/${url}`;
      return fullUrl;
    },
    // 添加 getDate 方法
    getDate(dateString) {
      if (!dateString) return "";
      const date = new Date(dateString);
      return date.toLocaleDateString("zh-TW");
    },

    // 檢查是否有付款憑證（支援新版多筆和舊版單一）
    hasPaymentProof(item) {
      if (!item) return false;
      if (item.payment_proofs && item.payment_proofs.length > 0) return true;
      return !!(item.payment_proof_path || item.payment_proof_url);
    },

    // 獲取付款憑證編號（支援多筆：顯示第一筆 + 總數）
    getPaymentProofNumber(item) {
      if (item.payment_proofs && item.payment_proofs.length > 0) {
        if (item.payment_proofs.length === 1) return item.payment_proofs[0].payment_proof_number;
        const first = item.payment_proofs[0].payment_proof_number;
        return `${first} 等 ${item.payment_proofs.length} 筆`;
      }
      return item.payment_proof_number || '';
    },

    // 檢查檔案類型（pdf / image），優先看第一筆多筆憑證
    getPaymentProofFileType(item) {
      let fileUrl = '';
      if (item.payment_proofs && item.payment_proofs.length > 0) {
        const p = item.payment_proofs[0];
        fileUrl = p.payment_proof_url || p.payment_proof_path || '';
      } else {
        fileUrl = item.payment_proof_url || item.payment_proof_path || '';
      }
      return fileUrl.toLowerCase().indexOf('.pdf') > -1 ? 'pdf' : 'image';
    },

    // 獲取付款憑證圖片 URL（支援多筆：取第一筆做縮圖）
    getPaymentProofImageUrl(item) {
      if (item.payment_proofs && item.payment_proofs.length > 0) {
        const first = item.payment_proofs[0];
        return this.getFullImageUrl(first.payment_proof_url || first.payment_proof_path);
      }
      return this.getFullImageUrl(item.payment_proof_url || item.payment_proof_path);
    },

    // 獲取付款收據圖片 URL
    getPaymentReceiptImageUrl(item) {
      return this.getFullImageUrl(
        item.payment_receipt_url || item.payment_receipt_path
      );
    },



    getFormatedDate(date) {
      const mm = date.getMonth() + 1;
      const dd = date.getDate();

      return [
        date.getFullYear(),
        (mm > 9 ? "" : "0") + mm,
        (dd > 9 ? "" : "0") + dd,
      ].join("-");
    },
    // 註釋掉原本的手動埋數功能
    // handleApproval(item) {
    //   this.approveData = item;
    //   this.$bvModal.show("modal-approval");
    // },
    handleViewDetail(item) {
      this.$store
        .dispatch("supplier/fetchSupplierDocumentDetail", { id: item.id })
        .then((response) => {
          this.documentDetailData = response.data.document;
          this.$bvModal.show("modal-supplier-document-detail");
        })
        .catch((error) => {
          this.$swal({
            text: error.response?.data?.message || "獲取帳單詳情失敗",
            icon: "error",
            customClass: {
              confirmButton: "btn btn-primary",
            },
            showClass: {
              popup: "animate__animated animate__bounceIn",
            },
            buttonsStyling: false,
          });
        });
    },
    handleModelDocument(item) {
      if (item) {
        this.documentData = item;
      } else {
        this.documentData = {
          id: 0,
          items: [{ id: 0, invoice_id: 0, amount: 0, title: "", file: null }],
        };
      }
      this.$bvModal.show("modal-upload-bill");
    },
    handleUploadPaymentProof(item) {
      this.selectedBillData = item;
      // 判斷是否為編輯模式（已有付款憑證）
      this.isEditPaymentProof = this.hasPaymentProof(item);

      // 設置付款憑證數據，包含現有的付款憑證資訊
      this.selectedPaymentProofData = {
        id: item.id,
        payment_proof_number: item.payment_proof_number,
        payment_date: item.payment_date,
        payment_amount: item.payment_amount || item.bill_total_amount,
        payment_method_id: item.payment_method_id,
        check_number: item.check_number,
        payment_proof_path: item.payment_proof_path,
        payment_proof_url: item.payment_proof_url,
        ...item.payment_proof,
      };
      this.$bvModal.show("modal-upload-payment-proof");
    },
    handleUploadPaymentReceipt(item) {
      this.selectedBillData = item;
      // 判斷是否為編輯模式（已有付款收據）
      this.isEditPaymentReceipt = !!(
        item.payment_receipt_path || item.payment_receipt_url
      );

      // 設置付款憑證數據
      this.selectedPaymentProofData = {
        id: item.id,
        payment_proof_number: item.payment_proof_number,
        payment_date: item.payment_date,
        payment_amount: item.payment_amount || item.bill_total_amount,
        payment_method_id: item.payment_method_id,
        check_number: item.check_number,
        payment_proof_path: item.payment_proof_path,
        payment_proof_url: item.payment_proof_url,
        ...item.payment_proof,
      };
      // 設置付款收據數據
      this.selectedPaymentReceiptData = {
        id: item.id,
        receipt_date: item.receipt_date,
        receipt_number: item.receipt_number,
        remark: item.payment_receipt_remark,
        payment_receipt_path: item.payment_receipt_path,
        payment_receipt_url: item.payment_receipt_url,
        ...item.payment_receipt,
      };
      this.$bvModal.show("modal-upload-payment-receipt");
    },
    handlePrintBillDetail(item) {
      // 跳轉到帳單明細列印頁面
      this.$router.push({
        name: "supplier-bill-detail-print",
        params: { id: item.id },
      });
    },
    previewPaymentProof(item) {
      let previewImages = [];
      if (item.payment_proofs && item.payment_proofs.length > 0) {
        previewImages = item.payment_proofs.map((proof, index) => ({
          id: proof.id,
          src: proof.payment_proof_url || proof.payment_proof_path,
          name: `付款憑證 ${index + 1} - ${proof.payment_proof_number}`,
          type: (proof.payment_proof_url || proof.payment_proof_path || '').toLowerCase().indexOf('pdf') > -1
            ? 'application/pdf'
            : 'image/jpeg',
        }));
      } else {
        previewImages = [
          {
            id: item.id,
            src: item.payment_proof_url || item.payment_proof_path,
            name: '付款憑證',
            type: (item.payment_proof_url || item.payment_proof_path || '').toLowerCase().indexOf('pdf') > -1
              ? 'application/pdf'
              : 'image/jpeg',
          },
        ];
      }
      this.previewImage = previewImages;
      this.selected_file = 0;
      this.$bvModal.show('modal-image-viewer');
    },
    previewPaymentReceipt(item) {
      this.previewImage = [
        {
          id: item.id,
          src: item.payment_receipt_url,
          name: "付款收據",
          type:
            item.payment_receipt_url.indexOf("pdf") > -1
              ? "application/pdf"
              : "image/jpeg",
        },
      ];
      this.selected_file = 0;
      this.$bvModal.show("modal-image-viewer");
    },
    getDate(dateString) {
      if (!dateString) return "";
      const date = new Date(dateString);
      return date.toLocaleDateString("zh-TW", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      });
    },
    previewImageSet(item, index) {
      console.log("item", item);
      if (item && item.length > 0) {
        this.previewImage = item.map((ele) => {
          return {
            id: ele.id,
            src: ele.image_url,
            name: ele.name,
            type:
              ele.image_path.indexOf("pdf") > -1
                ? "application/pdf"
                : "image/jpeg",
          };
        });
      } else {
        this.previewImage = [];
      }
      this.selected_file = index;

      setTimeout(() => {
        this.$bvModal.show(`modal-image-viewer`);
      });
    },
    removeDocument(id) {
      this.$swal({
        title: "你確定嗎?",
        text: "您的決定是最終決定，您將無法取回這記錄。",
        showCancelButton: true,
        confirmButtonText: "刪除",
        cancelButtonText: "取消",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.$store
            .dispatch("supplier/deleteSupplierDocument", { id })
            .then((response) => {
              this.$swal({
                text: response.data.message,
                icon: "success",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
              this.refetchData();
            })
            .catch((error) => {
              this.$swal({
                text: error.response.data.message,
                icon: "error",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
            });
        }
      });
    },
    makeToast(variant = null, title = null, content = null) {
      this.$bvToast.toast(content, {
        title: title,
        variant,
        solid: true,
      });
    },
    deleteRecord(id, apiKey) {
      // 設定不同的確認訊息
      let confirmText = "您的行動是最終的，您將無法檢索記錄。";
      if (apiKey === 'deleteSupplierBillFiles') {
        confirmText = "您將刪除此帳單的所有檔案，但帳單記錄將保留。";
      } else if (apiKey === 'deleteSupplierPaymentProof') {
        confirmText = "您的行動是最終的，您將無法檢索付款憑證記錄。";
      } else if (apiKey === 'deleteSupplierPaymentReceipt') {
        confirmText = "您的行動是最終的，您將無法檢索付款收據記錄。";
      }

      this.$swal({
        title: "你確定嗎?",
        text: confirmText,
        showCancelButton: true,
        confirmButtonText: "刪除",
        cancelButtonText: "取消",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          const params = { id: id };

          this.$store
            .dispatch(`supplier/${apiKey}`, params)
            .then((response) => {
              this.$swal({
                text: response.data.message,
                icon: "success",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                buttonsStyling: false,
              });
              // 刷新頁面
              this.$router.go(0);
            })
            .catch((error) => {
              if (error.response && error.response.data && error.response.data.message) {
                this.$swal({
                  text: error.response.data.message,
                  icon: "error",
                  customClass: {
                    confirmButton: "btn btn-primary",
                  },
                  buttonsStyling: false,
                });
              }
            });
        }
      });
    },
  },
  setup() {
    const vm = getCurrentInstance();
    const supplierData = ref({});

    const supplier_APP_STORE_MODULE_NAME = "supplier";

    if (!store.hasModule(supplier_APP_STORE_MODULE_NAME))
      store.registerModule(supplier_APP_STORE_MODULE_NAME, supplierStoreModule);

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(supplier_APP_STORE_MODULE_NAME))
        store.unregisterModule(supplier_APP_STORE_MODULE_NAME);
    });

    const refSupplierDocumentListTable = ref(null);
    const supplierDocuments = ref([]);
    const totalAmount = ref(0);
    const approvedAmount = ref(0);
    const pendingAmount = ref(0);
    const expenseTypeFilter = ref("all");
    const approvalStatusFilter = ref("all");
    const totalSupplierDocuments = ref(0);
    const isSubmitDocument = ref(false);
    const isExporting = ref(false);
    const expenseTypeOptions = [
      { label: "全部", value: "all" },
      { label: "日常開支", value: "1" },
      { label: "成本開支", value: "0" },
    ];
    const approvalStatusOptions = [
      { label: "全部", value: "all" },
      { label: "已埋數", value: "1" },
      { label: "未埋數", value: "0" },
    ];
    const fetchSupplierDocuments = (ctx, callback) => {
      store
        .dispatch("supplier/fetchSupplierDocuments", {
          supplier_id: router.currentRoute.params.id,
          is_daily_expense:
            expenseTypeFilter.value === "all" ? null : expenseTypeFilter.value,
          approval_status:
            approvalStatusFilter.value === "all"
              ? null
              : approvalStatusFilter.value,
        })
        .then((response) => {
          const {
            documents,
            total,
            total_amount,
            approved_amount,
            pending_amount,
          } = response.data;
          callback(documents);
          supplierDocuments.value = documents;
          totalSupplierDocuments.value = total;
          totalAmount.value = total_amount || 0;
          approvedAmount.value = approved_amount || 0;
          pendingAmount.value = pending_amount || 0;
        })
        .catch((error) => {
          console.log("error when fetching supplier documents", error);
          if (error.response.status === 404) {
            supplierDocuments.value = [];
          }
        });
    };

    const refetchData = () => {
      store
        .dispatch("supplier/fetchSupplier", {
          id: router.currentRoute.params.id,
        })
        .then((response) => {
          supplierData.value = response.data.entity;
          refSupplierDocumentListTable.value.refresh();
          // documents.value = response.data.entity.documents
        })
        .catch((error) => {
          console.log("error when fetching supplier", error);
          if (error.response.status === 404) {
            supplierData.value = undefined;
          }
        });
    };

    const paymentMethodStatusOptions = ref([]);
    const paymentMethodOptions = ref([]);
    const userDocumentTypeOptions = ref([]);
    const invoiceOptions = ref([]);

    const refetchOption = () => {
      store
        .dispatch("app/fetchOptionList", {
          payment_methods: true,
          receive_methods: true,
          user_document_types: true,
          invoices: true,
        })
        .then((response) => {
          paymentMethodStatusOptions.value = response.data.payment_methods;
          paymentMethodOptions.value = response.data.receive_methods.sort ((a, b) => a.sort_order - b.sort_order);
          userDocumentTypeOptions.value = response.data.user_document_types;
          invoiceOptions.value = response.data.invoices;
        });
    };

    const documentTableColumns = ref([
      { key: "bill_preview", label: "帳單" },
      { key: "payment_proof_preview", label: "付款憑證" },
      { key: "payment_receipt_preview", label: "付款收據" },
      { key: "bill_date", label: "帳單日期" },
      { key: "bill_total_amount", label: "帳單總金額", formatter: formatCurrency },
      { key: "is_daily_expense", label: "日常開支" },
      { key: "show_details", label: "詳情" },
      { key: "actions", label: "操作" },
      { key: "is_approved", label: "埋數" },
      // { key: "remark", label: "埋數備註" },
      { key: "approve_user.name_cn", label: "埋數人員" },
    ]);

    const getInvoiceNumber = (invoice_id) => {
      const invoice = invoiceOptions.value.find(
        (invoice) => invoice.id === invoice_id
      );
      return invoice ? invoice.invoice_number : "";
    };

    const handleExport = async () => {
      if (isExporting.value) return;

      isExporting.value = true;

      try {
        const exportParams = {
          supplier_id: router.currentRoute.params.id,
          is_daily_expense:
            expenseTypeFilter.value === "all" ? null : expenseTypeFilter.value,
          approval_status:
            approvalStatusFilter.value === "all"
              ? null
              : approvalStatusFilter.value,
        };

        const response = await store.dispatch(
          "supplier/exportSupplierDocuments",
          exportParams
        );

        // 生成動態文件名，包含匯出日期
        const supplierName =
          supplierData.value.name_cn ||
          supplierData.value.company_name_cn ||
          "供應商";
        const currentDate = new Date().toISOString().split("T")[0]; // YYYY-MM-DD 格式
        const fileName = `${supplierName}_帳單明細_${currentDate}.xlsx`;

        // 創建下載連結
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);

        // 顯示成功提示
        vm.proxy.$bvToast.toast("Excel 檔案已成功下載", {
          title: "匯出成功",
          variant: "success",
          solid: true,
          autoHideDelay: 3000,
        });
      } catch (error) {
        console.error("匯出失敗:", error);

        // 顯示錯誤提示
        vm.proxy.$bvToast.toast(
          error.response?.data?.message || "匯出過程中發生錯誤，請稍後再試",
          {
            title: "匯出失敗",
            variant: "danger",
            solid: true,
            autoHideDelay: 5000,
          }
        );
      } finally {
        isExporting.value = false;
      }
    };

    // Watch for filter changes
    watch([expenseTypeFilter, approvalStatusFilter, isSubmitDocument], () => {
      refSupplierDocumentListTable.value.refresh();
    });

    onMounted(() => {
      refetchData();
      refetchOption();
    });

    function getPaymentMethodName(paymentMethodId, checkNumber = null) {
      if (
        !paymentMethodId ||
        !paymentMethodOptions.value ||
        !paymentMethodOptions.value.length
      ) {
        return "-";
      }
      const method = paymentMethodOptions.value.find(
        (m) => m.id === paymentMethodId
      );
      if (!method) return "-";

      // 如果是支票支付方式（payment_method_id == 1）且有支票號碼
      if (paymentMethodId == 1 && checkNumber) {
        return `${method.name} - ${checkNumber}`;
      }

      return method.name;
    }

    return {
      refSupplierDocumentListTable,
      fetchSupplierDocuments,
      supplierData,
      refetchData,
      paymentMethodStatusOptions,
      userDocumentTypeOptions,
      invoiceOptions,
      documentTableColumns,
      supplierDocuments,
      totalAmount,
      approvedAmount,
      pendingAmount,
      totalSupplierDocuments,
      getInvoiceNumber,
      handleExport,
      expenseTypeFilter,
      expenseTypeOptions,
      approvalStatusFilter,
      approvalStatusOptions,
      paymentMethodOptions,
      isSubmitDocument,
      isExporting,
      getPaymentMethodName,
    };
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@/assets/scss/variables/_variables.scss";

// 確保 badge 顏色正確顯示
.badge {
  &.badge-success {
    background-color: #28a745 !important;
    color: #fff !important;
  }

  &.badge-danger {
    background-color: #dc3545 !important;
    color: #fff !important;
  }

  &.badge-warning {
    background-color: #ffc107 !important;
    color: #212529 !important;
  }

  &.badge-light {
    background-color: #f8f9fa !important;
    color: #6c757d !important;
    border: 1px solid #dee2e6 !important;
  }
}
</style>
<style lang="scss" scoped>
.info-wrap {
  .info-label {
    display: inline-block;
    width: 100px;
  }
  .info-item {
    margin-bottom: 1rem;
    .icon {
      display: inline-block;
      margin-right: 1rem;
      width: 15px;
      svg {
        margin: auto;
        display: block;
      }
    }
  }
}

.bill-details,
.payment-proof-details,
.payment-receipt-details {
  .label {
    min-width: 80px;
    display: inline-block;
    color: #6c757d;
    font-weight: 600;
  }

  .backgroundColor2 {
    background-color: #fff3cd !important;
    border-left: 4px solid #ffc107 !important;
  }

  .backgroundColor3 {
    background-color: #d1ecf1 !important;
    border-left: 4px solid #17a2b8 !important;
  }

  .backgroundColor5 {
    background-color: #d4edda !important;
    border-left: 4px solid #28a745 !important;
  }
}

// 預覽欄位樣式
.preview-column {
  min-width: 120px;

  .btn-sm {
    padding: 0.25rem 0.5rem;
    font-size: 0.75rem;
    border-radius: 0.25rem;

    .feather {
      margin-right: 0.25rem;
    }
  }

  .btn-outline-primary {
    border-color: #007bff;
    color: #007bff;

    &:hover {
      background-color: #007bff;
      color: white;
    }
  }

  .btn-outline-success {
    border-color: #28a745;
    color: #28a745;

    &:hover {
      background-color: #28a745;
      color: white;
    }
  }

  .btn-outline-warning {
    border-color: #ffc107;
    color: #ffc107;

    &:hover {
      background-color: #ffc107;
      color: white;
    }
  }
}

// 詳情區域樣式

.details-container {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-radius: 12px;
  margin: 15px 0;
  border-left: 4px solid #17a2b8;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  display: flex;
  gap: 1.5rem;
}

.detail-section {
  margin-bottom: 1.5rem;
}
.detail-header {
  margin-bottom: 1rem;
}
.detail-icon {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  transition: transform 0.2s ease;
  &:hover {
    transform: scale(1.05);
  }
}
.detail-content {
  border: 1px solid #e9ecef;
  transition: box-shadow 0.3s ease;
  &:hover {
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.08);
  }
}

.detail-row {
  align-items: flex-start;
  min-height: 24px;
}

.detail-label {
  min-width: 100px;
  font-size: 0.875rem;
  font-weight: 500;
  flex-shrink: 0;
}

.detail-value {
  font-size: 0.875rem;
  word-break: break-word;
  flex: 1;
}

.bill-item:last-child {
  border-bottom: none !important;
  margin-bottom: 0 !important;
  padding-bottom: 0 !important;
}

// 響應式設計
@media (max-width: 768px) {
  .details-container {
    padding: 1rem;
  }

  .detail-row {
    flex-direction: column;
    margin-bottom: 0.75rem;
  }

  .detail-label {
    min-width: auto;
    margin-bottom: 0.25rem;
  }

  .detail-value {
    margin-left: 0 !important;
  }
}

// 上傳按鈕樣式
.upload-btn {
  font-size: 0.75rem;
  padding: 0.25rem 0.5rem;
  border-radius: 0.25rem;
  transition: all 0.2s ease-in-out;

  &:hover:not(:disabled) {
    transform: translateY(-1px);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }

  .feather {
    vertical-align: middle;
  }
}

.previewWrapper{
  display:flex;
  align-items: center;
  justify-content: center;
  width: 120px;
  height: 80px;
  overflow: hidden;
  margin:auto;
}
</style>
